/**
 * Service for retrieving feature flags / experiments configuration.
 *
 * Responsibilities:
 * - Fetch experiments list for the current page source.
 */
import type { IExperimentList } from "../types";
import type { ApiClient } from "@/common/api/http/types";

export default class ExperimentsService {
  public constructor(private readonly client: ApiClient) {}

  async getExperiments(): Promise<IExperimentList> {
    const query = new URLSearchParams();
    query.append("source", window.location.href);

    return await this.client.get(`v2/experiments/all?${query.toString()}`);
  }
}
